"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isWhiteListed = exports.YOUTUBE = exports.VIRTUAL_TOUR = exports.VIRTUALTOURS = exports.VIMEO = exports.VIDEO = exports.UNKNOWN = exports.SCANN3D = exports.PLAT_HD = exports.MP4 = exports.MATTERPORT = exports.LITTLEHINGES = exports.KUULA = exports.ISTAGING = exports.INVALID = exports.IMAGE = exports.IGUIDE = exports.FLOORPLAN_3D = exports.FLOORPLAN = exports.DIAKRIT_PANORAMA = exports.DIAKRIT_FURNISH = exports.CRAPPY = exports.CLOUDPANO = exports.CAPTUR3D = void 0;
exports.linkTypeLabel = linkTypeLabel;
exports.parseTours = exports.parseListingMedia = exports.parseLinks = exports.parseLink = void 0;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _url = _interopRequireDefault(require("url"));
var _queryString = _interopRequireDefault(require("query-string"));
var _hashes = require("@raywhite/helpers-utils/lib/helpers/hashes");
// const { phash } = hashes;

// Recognised non-image media `type`s.
var UNKNOWN = exports.UNKNOWN = 'UNKNOWN';
var INVALID = exports.INVALID = 'INVALID';
var YOUTUBE = exports.YOUTUBE = 'YOUTUBE_VIDEO';
var VIMEO = exports.VIMEO = 'VIMEO_VIDEO';
var MATTERPORT = exports.MATTERPORT = 'MATTERPORT_3D_TOUR';
var LITTLEHINGES = exports.LITTLEHINGES = 'LITTLEHINGES_3D_TOUR';
var KUULA = exports.KUULA = 'KUULA_3D_TOUR';
var SCANN3D = exports.SCANN3D = 'SCANN3D_3D_TOUR';
var CLOUDPANO = exports.CLOUDPANO = 'CLOUDPANO_3D_TOUR';
var ISTAGING = exports.ISTAGING = 'ISTAGING_3D_TOUR';
var VIRTUALTOURS = exports.VIRTUALTOURS = 'VIRTUALTOURS_3D_TOUR';
var IGUIDE = exports.IGUIDE = 'IGUIDE_3D_TOUR';
var DIAKRIT_PANORAMA = exports.DIAKRIT_PANORAMA = 'DIAKRIT_PANORAMA';
var DIAKRIT_FURNISH = exports.DIAKRIT_FURNISH = 'DIAKRIT_FURNISH';
var CAPTUR3D = exports.CAPTUR3D = 'CAPTUR3D_3D_TOUR';
var PLAT_HD = exports.PLAT_HD = 'PLATINUMHD_VIDEO';
var MP4 = exports.MP4 = 'MP4_VIDEO';

// We need a special case for random virtual tour providers.
var CRAPPY = exports.CRAPPY = 'EXTERNAL_CRAP';

// Media `code`s.
var IMAGE = exports.IMAGE = 'IMG';
var VIDEO = exports.VIDEO = 'VID';
var FLOORPLAN = exports.FLOORPLAN = 'FLP';
var VIRTUAL_TOUR = exports.VIRTUAL_TOUR = 'VLT';
var FLOORPLAN_3D = exports.FLOORPLAN_3D = 'FP3';
var isWhiteListed = exports.isWhiteListed = function createWhiteList(_context) {
  // Whitelist for random crap virtual tours.
  var WHITE_LIST = (0, _reduce.default)(_context = ['kencurry.com.au', 'tours.v2b.com.au', 'proactivevue.com', 'myhomeis.com.au', 'vrm.gallery', 'nz.open2view.com', 'ticketyview.com' // Sweet domain name.
  ]).call(_context, (p, c) => {
    p.push(c, "www.".concat(c));
    return p;
  }, []);
  var hash = (0, _reduce.default)(WHITE_LIST).call(WHITE_LIST, (p, c) => {
    p[c] = true;
    return p;
  }, {});
  return hostname => !!hash[hostname];
}();

/**
 * This module is responsible for processing of the `links` returned from the
 * listings API, and implements the components for each.
 *
 * Each of the links will contain a `code`;
 *
 * code           description
 * EXT            External Link
 * VID            Video Link
 * FP3            3D Floorplan
 * VLT            Virtual Tour
 * COM            Community Video
 * PRO            Promotional Video
 * APL            AutoPlay Video
 *
 * These are generally unreliable and shouldn't be used to determine
 * whether the url should be treated as a specific type of content.
 *
 * Largely, this is a port of Liam's code which can be found @
 * http://stash.group.domain/projects/RWCORE/repos/zend/browse/src/Helper/View/PropertyLinks.php
 */
var linkTypeLabels = (0, _freeze.default)({
  EXT: 'More Info',
  [FLOORPLAN]: 'Floorplan',
  [VIDEO]: 'Video',
  [FLOORPLAN_3D]: '3D Floorplan',
  [VIRTUAL_TOUR]: 'Virtual Tour',
  COM: 'Community Video',
  PRO: 'Promotional Video',
  APL: 'Video'
});
function linkTypeLabel(link, code) {
  switch (true) {
    // Special handling for "auctions plus"
    case /^https?:\/\/(www\.)?auctionsplus.com.au/.test(link):
      return 'Full Assessment';
    default:
      return linkTypeLabels[code] || 'More Info';
  }
}

/**
 * Dedupes links (making sure that the same one doesn't occur twice). Also
 * strips out AutoPlay videos that are tagged with the code 'APL', as these
 * appear to always be duplicated onto youtube.
 *
 *
 * @param {Array} links for a listing
 * @return {Array} inoput stripped of dups and 'APL' videos.
 */
var dedupe = links => {
  var _context2, _context3;
  var _links = (0, _reduce.default)(links).call(links, (p, c) => {
    p[c.url] = c;
    return p;
  }, {});
  return (0, _filter.default)(_context2 = (0, _map.default)(_context3 = (0, _keys.default)(_links)).call(_context3, k => _links[k])
  // Strip AutoPlay videos (they should be on youtube).
  ).call(_context2, link => link.code !== 'APL');
};

/**
 * Parses a url to make a best effort guess about what sort of content
 * the resource is. The returned object contains a 'code' (category) and
 * 'type' (a specific provider). Where the type of the url cannot me
 * detected, the original `code` provided by ES will be preserved, but
 * the type be set to the default (unkown).
 *
 * @param {Object} the raw `link` object from elastic
 *
 * @return {Object} a constant represtenting the determined type
 */
var parseLink = link => {
  var _context4;
  var ret = {
    ...link,
    type: UNKNOWN,
    hash: (0, _hashes.phash)(link.url)
  };
  var {
    hash,
    hostname,
    path,
    pathname,
    protocol,
    query
  } = _url.default.parse(link.url);

  // Strip anything that's not http(s)
  if (protocol && (0, _indexOf.default)(_context4 = ['https:', 'http:']).call(_context4, protocol) === -1) {
    ret.type = INVALID;
    ret.code = INVALID;
    return ret;
  }
  if (!protocol || !hostname || (0, _indexOf.default)(hostname).call(hostname, '.') === -1) {
    ret.type = INVALID;
    ret.code = INVALID;
    return ret;
  }

  // Whitelisted domains - these should open externally.
  if (isWhiteListed(hostname)) {
    ret.type = CRAPPY;
    ret.code = VIRTUAL_TOUR;
    return ret;
  }

  // youtube, youtube embed and youtube short `share` urls.
  if (/^(?:www.)?youtu(\.be|be\.com)$/.test(hostname)) {
    // Capture the id in the path, or check for it in the query string.
    var match = /\/([\w-]{6,})\/?$/.exec(pathname);
    var id = match && match[1] || query && _queryString.default.parse(query).v;
    if (id) {
      ret.type = YOUTUBE;
      ret.code = VIDEO;
      ret.id = id;
    }
    return ret;
  }

  // Vimeo; think this covers everything. So nice to parse.
  if (/(?:player.)?vimeo\.com/.test(hostname)) {
    var _match = /\/(\d+$)$/.exec(path);
    if (_match) {
      ret.type = VIMEO;
      ret.code = VIDEO;
      ret.id = _match[1];
    }
    return ret;
  }

  // Matterport; also pretty easy to detect.
  if (/(?:my\.)?matterport.com$/.test(hostname) && (query || hash)) {
    var _id = _queryString.default.parse(query || '').m || _queryString.default.parse(hash || '').m;
    if (_id) {
      ret.type = MATTERPORT;
      ret.code = VIRTUAL_TOUR;
      ret.id = _id;
    }
    return ret;
  }

  // Littlehinges is a Matterport reseller but they use a different URL structure
  if (hostname === 'openhouse.littlehinges.com.au' && (pathname === null || pathname === void 0 ? void 0 : pathname.length) > 1) {
    ret.type = LITTLEHINGES;
    ret.code = VIRTUAL_TOUR;
    ret.id = (0, _slice.default)(pathname).call(pathname, 1);
    return ret;
  }

  // e.g. https://kuula.co/share/collection/7lZlB?fs=1&vr=1&zoom=1&autorotate=-0.06&thumbs=1&chromeless=1&logo=1&logosize=88
  if (hostname === 'kuula.co' || hostname === 'mls.kuu.la') {
    var _match2 = /^\/share\/((?:(?:collection|post)\/)?[a-zA-Z0-9]+)\/?/.exec(pathname);
    if (_match2) {
      ret.type = KUULA;
      ret.code = VIRTUAL_TOUR;
      ret.id = _match2[1];
    }
    return ret;
  }

  // Scann3D - they've mispelled `scan`, like Scott mispells `little`.
  // TODO: I didn't have a large corpus of scann3d videos, more work is
  // needed to make sure that the majority of cases are being covered.
  if (/^(?:api\.|www\.|)scann3d.com.au$/.test(hostname)) {
    var _match3 = /^(?:\/players\/|\/view\/v1\/)([\w\d-]+\/[\w\d-]+)\/?$/.exec(pathname);
    if (_match3) {
      ret.type = SCANN3D;
      ret.code = VIRTUAL_TOUR;
      ret.id = _match3[1];
    }
    return ret;
  }
  if (hostname === 'app.cloudpano.com') {
    var _match4 = /^\/?tours\/([a-zA-Z0-9]+)\/?/.exec(pathname);
    if (_match4) {
      ret.type = CLOUDPANO;
      ret.code = VIRTUAL_TOUR;
      ret.id = _match4[1];
    }
    return ret;
  }
  if (hostname === 'livetour.istaging.com') {
    var _match5 = /^\/?([0-9a-z-]+)\/?$/.exec(pathname);
    if (_match5) {
      ret.type = ISTAGING;
      ret.code = VIRTUAL_TOUR;
      ret.id = _match5[1];
    }
    return ret;
  }
  if (hostname === 'vtc.virtualtourscreator.com.au') {
    var _match6 = /^\/?share\/([0-9a-z-]+)\/?$/.exec(pathname);
    if (_match6) {
      ret.type = VIRTUALTOURS;
      ret.code = VIRTUAL_TOUR;
      ret.id = _match6[1];
    }
    return ret;
  }

  // captur3d
  // e.g. https://little-hinges.captur3d.io/view/ray-white-3/2-39-anembo-st-chevron-island-qld-4217-australia
  if (/.*\.captur3d.io/.test(hostname)) {
    var _match7 = /\/view\/(.+)/.exec(pathname);
    if (_match7) {
      ret.type = CAPTUR3D;
      ret.code = VIRTUAL_TOUR;
      ret.id = _match7[1].replace(/\/$/, '');
    }
    return ret;
  }

  // iGuide
  // e.g. https://youriguide.com/4_91_springfield_rd_christchurch_can_nz/
  if (hostname === 'youriguide.com') {
    var _match8 = /^\/([^/]+)(\/.*)?$/.exec(pathname);
    if (_match8) {
      ret.type = IGUIDE;
      ret.code = VIRTUAL_TOUR;
      ret.id = _match8[1];
    }
    return ret;
  }

  // Diakrit Panorama
  // e.g. https://cdn.diakrit.com/product/panorama/11448642
  if (hostname === 'cdn.diakrit.com') {
    var _match9 = /^\/product\/(furnish|panorama)\/([0-9]+)/.exec(pathname);
    if (_match9) {
      ret.type = _match9[1] === 'panorama' ? DIAKRIT_PANORAMA : DIAKRIT_FURNISH;
      ret.code = VIRTUAL_TOUR;
      ret.id = _match9[2];
    }
    return ret;
  }

  // e.g. https://app.cloudpano.com/tours/ecaWI7Gqr
  /**
   * platinumhd; they have several different url schemas that could be used -
   * going from 20K current listings in ES, I've come up with the following, note that
   * the schemas that I'm trying to detect have changed since the last time platinumhd
   * detection code was written.
   *
   * The most common, and most parsable is of the form `https://platinumhd.tv/embed/<id>.html`,
   * slight variation of this is `https://platinumhd.tv/?v=<id>` or
   * `https://platinumhd.tv/?c=<id>` or `https://platinumhd.tv/theatre/<id>.html`
   *
   * `http://vcdn.platinumhd.tv/<some-giant-hash>.mp4` or `http://cdn.platinumhd.tv/<some-giant-hash>.mp4`
   * are serving the .mp4 resource from a cdn and will be handled as such later.
   *
   * `platinumhd.tv/videos/residential/au/gold-coast/reedy-creek/76-observatory-drive-35590.html` is
   * the worst kind of short url (a long one). The only way to handle it would be
   * to make a request for the resource and get the 301 redirects location.
   * Fortunately, in almost all cases (`841546` is an example of an exception),
   * the same video has also been uploaded to youtube, and the platinumhd link has
   * the code `EXT`, so these can be filtered.
   *
   * TODO: As an added bit of fuckery, platinumhd now resell matterport 3d scans
   * the urls for these look like `http://platinumhd.tv/3d-scan/<id>.html`
   * or `https://platinumhd.tv/?c=<id>`, note that the latter is indistinguishable
   * from many videos. These need to be dealt with accordingly.
   */
  if (/(?:www\.)?platinumhd.tv$/.test(hostname)) {
    var _id2;
    if (/^\/(external\/embed\.php)/.test(pathname) || pathname === '/') {
      var search = _queryString.default.parse(query);
      _id2 = search.c || search.v;
    } else {
      var _match10 = /^\/(?:embed|theatre|3d-scan)\/(\w+)(?:\.html)?$/.exec(pathname);
      _id2 = _match10 && _match10[1];
    }
    if (_id2) {
      ret.type = PLAT_HD;
      ret.code = VIDEO;
      ret.id = _id2;
      return ret;
    }
  }

  // mp4's, typically hosted on AWS or by platinumhd (see above)
  if ((0, _slice.default)(pathname).call(pathname, -4).toLowerCase() === '.mp4') {
    ret.code = VIDEO;
    ret.type = MP4;

    // Ensure that known AWS content is loaded over HTTPS
    ret.url = ret.url.replace('http://ap-realestate.s3.amazonaws.com', 'https://ap-realestate.s3.amazonaws.com');
  }
  // If it's a 3D floorplan and we haven't matched it yet, marking it as CRAPPY will do
  if (link.code === FLOORPLAN_3D || link.code === VIRTUAL_TOUR) {
    ret.type = CRAPPY;
    ret.code = VIRTUAL_TOUR;
  }
  return ret;
};

/**
 * Takes an array of links as returned by Elastic and returns an object
 * containing `external` and `media` arrays, that can be used to build
 * the a gallery and a list of external links.
 *
 * @param {Array} links
 * @return {Object} an object containing the parsed links
 */
exports.parseLink = parseLink;
var parseLinks = links => {
  var _context5;
  var parsed = (0, _map.default)(_context5 = dedupe(links)).call(_context5, parseLink);
  return (0, _reduce.default)(parsed).call(parsed, (p, c) => {
    var {
      external,
      tours,
      videos
    } = p;
    switch (c.type) {
      case INVALID:
        return p;
      case UNKNOWN:
        // Has an unknown `type`, but the original 'code' is preserved.
        external.push(c);
        return p;
      default:
        if (c.code === VIDEO) {
          videos.push(c);
          return p;
        }
        tours.push(c);
        return p;
    }
  }, {
    videos: [],
    tours: [],
    external: []
  });
};

/**
 * Takes an array of tours (possible VID, EXT, FP3) and splits it
 * according to type for better counting and labelling
 *
 * @param {Array} tours
 * @return {Object} an object containing the sorted tours by code
 */
exports.parseLinks = parseLinks;
var parseTours = tours => (0, _reduce.default)(tours).call(tours, (result, tour) => {
  var {
    code
  } = tour;
  result[code] = result[code] || [];
  var coded = result[code];
  coded.push(tour);
  return result;
}, {});

/**
 * Parses images from ES, (clones and adds a hash).
 *
 * @param {Object} an image
 *
 * @return {Object} parsed image
 */
exports.parseTours = parseTours;
var parseImages = images => (0, _map.default)(images).call(images, i => ({
  ...i,
  hash: (0, _hashes.phash)(i.url),
  code: IMAGE
}));

/**
 * Parses floor plans from ES, (clones and adds a hash).
 *
 * @param {Object} a floorplan image
 *
 * @return {Object} parsed floorplan image
 */
var parsePlans = plans => (0, _map.default)(plans).call(plans, p => ({
  ...p,
  hash: (0, _hashes.phash)(p.url),
  code: FLOORPLAN
}));

/**
 * Parse all listings media and returns an object containing `external, videos,
 * tours, plans and images` arrays (different media types), together with a
 * `hashes` array - which is an ordered list of hashes for all of the visual
 * media that would be included in the PDP or gallery.
 *
 * @param {Object} media - `{ images, plans, links }`
 *
 * @return {Object} the cleaned up media object `{ external, videos, tours, plans, images, hashes }`
 */
var parseListingMedia = exports.parseListingMedia = (() => {
  var cache = {};
  var parse = _ref => {
    var _context6;
    var {
      images = [],
      links = [],
      plans = []
    } = _ref;
    var key = (0, _map.default)(_context6 = [...images, ...plans, ...links]).call(_context6, i => i.url).join('');
    if (cache[key]) {
      return cache[key];
    }
    var media = {
      ...parseLinks(links),
      plans: parsePlans(plans),
      images: parseImages(images)
    };
    cache[key] = media;
    return media;
  };
  parse.cache = cache;
  return parse;
})();